import Button from './Button.vue';

// @ts-ignore
Button.install = (Vue) => {
  Vue.component((Button as any).options.name, Button);
};

export default Button;
